
<div id="wrapper" *ngIf="false">
  <app-menu *ngIf="!global.isIframe"></app-menu>
  <div class="allcont logsize">
    <div class="basicrow">
      <div class="">
        <div class="basicrow">
          <div class="text-center mob-hid " [ngClass]="{'text-center mob-hid div-left' :!global.isIframe,
          'text-center mob-hid ':global.isIframe}">
            <img width="100%" class="neg-img" src="../../assets/images/logphoto.jpg">
          </div>
          <div class="log-mob mob-pos adj-pos div-right" *ngIf="!global.isIframe">
            <form [formGroup]="loginForm">
              <div class="basicrow f-bigmed roboto-m">
                <img width="100%" class="mc-icon" src="../../assets/images/miclaro-icon.png">
                <div class="basicrow f-title txt-center-log">
                  Iniciar Sesión
                </div>
              </div>
              <div class="basicrow m-top">
                <label class="label-f">Correo Electrónico o Número de Teléfono</label>
                <div class="basicrow">
                  <input (keypress)="this.global.validateInputKey($event)" (blur)="this.global.validateInputKey($event)"
                         placeholder="" class="inp-f" required formControlName="username" id="username" autocomplete="off">
                  <div [hidden]="loginForm.controls.username.valid || loginForm.controls.username.untouched"
                       class="alert alert-danger">
                    Usuario Requerido
                  </div>
                </div>
              </div>
              <div class="basicrow m-top-i">
                <label class="label-f">Contrase&ntilde;a</label>
                <div class="basicrow">
                  <input (keypress)="this.getIn($event);" (blur)="this.global.validateInputKey($event)"
                         class="inp-f" required formControlName="password" id="password" type="password" autocomplete="off">
                  <div [hidden]="loginForm.controls.password.valid || loginForm.controls.password.untouched"
                       class="alert alert-danger">
                    Contraseña Requerida
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px; width: 100%; float: left;">
                Por favor, demuestre que es un humano.
              </div>
              <div class="box-captcha">
                <div class="h-captcha">
                  <div class="content-captcha">
                    <ngx-recaptcha2 #captchaElem [siteKey]="this.siteKey" formControlName="recaptcha">
                    </ngx-recaptcha2>
                  </div>
                </div>
                <div class="box-remember">
                  <input type="checkbox"> Recordar Usuario
                </div>
              </div>
              <div class="basicrow m-top-u-ii buttons">
                <div class="erase-data">
                  <a (click)="erase()" class="btns gray vcenter">
                    <span class="tabcell">
                      Borrar&nbsp;&nbsp;<i class="fa fa-times" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>

                <div class="login-user">
                  <a (click)="login()" class="btns red vcenter"
                     [ngClass]="{'red': !loginForm.invalid, 'gray': loginForm.invalid}">
                    <span class="tabcell">
                      Ingresar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
              </div>

              <div class="basicrow text-center m-top-ii">
                <a routerLink="/forgotpassword" class="linkdefs">¿Olvidaste tu contraseña?&nbsp;&nbsp;<i
                  class="fa fa-angle-right" aria-hidden="true"></i></a>
              </div>
              <div class="basicrow m-top-u-ii">

                <a routerLink="/register" class="btns blue vcenter">
                  <span class="tabcell">
                    ¿No tienes cuenta? Regístrate&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer *ngIf="!global.isIframe"></app-footer>
</div>
